import * as RadixTooltip from '@radix-ui/react-tooltip';
import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';

interface ContentProps {
    $maxWidth?: string;
}

export const Content = styled(RadixTooltip.Content)<ContentProps>`
    background: ${theme.colors.background.emphasis};
    color: white;
    padding: 4px 8px;
    box-shadow: ${theme.shadows.medium};
    border-radius: 4px;
    max-width: ${(props) => props.$maxWidth ?? '240px'};
    z-index: ${theme.zIndex.interactive};
    white-space: normal;
    overflow-wrap: break-word;
    font-size: 12px;
    font-weight: ${theme.fontWeights[400]};
    line-height: 16px;
`;
